import AddIcon from "@mui/icons-material/Add";
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useLoaderData, useNavigate, useNavigation } from "react-router-dom";
import useDataGridPaging from "../../app/useDataGridPaging";
import { PagedResponse } from "../../types/Result";
import { User } from "../user/type";
import { userColumns } from "./columns";

export default function UserDataGrid() {
  const data = useLoaderData() as PagedResponse<User>;
  const navigate = useNavigate();
  const navigation = useNavigation();
  const {
    handlePaginationModelChange,
    handleSortModelChange,
    paginationModel,
    sortModel,
    handleFilterChange,
    filterModel,
  } = useDataGridPaging(data);
  return (
    <>
      <DataGrid
        autoHeight
        sx={{ width: "100%" }}
        rows={data.data!}
        getRowId={(row) => row.id}
        columns={userColumns}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
        }
        filterModel={filterModel}
        paginationModel={paginationModel}
        loading={navigation.state === "loading"}
        rowCount={data.totalCount}
        paginationMode="server"
        sortingMode="server"
        filterMode="server"
        pageSizeOptions={[10, 20, 50, 100]}
        disableColumnResize
        onSortModelChange={handleSortModelChange}
        onPaginationModelChange={handlePaginationModelChange}
        onFilterModelChange={handleFilterChange}
        sortModel={sortModel}
        density="compact"
        slotProps={{
          filterPanel: {
            filterFormProps: {
              logicOperatorInputProps: {
                variant: "outlined",
                size: "small",
              },
              columnInputProps: {
                variant: "outlined",
                size: "small",
                sx: { mt: "auto" },
              },
              operatorInputProps: {
                variant: "outlined",
                size: "small",
                sx: { mt: "auto" },
              },
              valueInputProps: {
                InputComponentProps: {
                  variant: "outlined",
                  size: "small",
                },
              },
            },
          },
        }}
      />
      <SpeedDial
        ariaLabel="SpeedDial basic example"
        sx={{ position: "fixed", bottom: 16, right: 3 }}
        icon={<SpeedDialIcon />}
      >
        <SpeedDialAction
          icon={<AddIcon />}
          tooltipTitle={"Yeni"}
          onClick={() => navigate("new")}
        />
      </SpeedDial>
    </>
  );
}
